(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stampadiko_sales_calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('.stampadiko-sales-calculator');
  roots.forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const state = { product: 'tshirt', qty: 1, front: 'A4', back: 'none', sleeves: 0 };
    const tiers = [
      { min: 1, max: 5, price: 19 },
      { min: 6, max: 10, price: 15 },
      { min: 11, max: 20, price: 13 },
      { min: 21, max: 50, price: 11 },
      { min: 51, max: 100, price: 9.5 },
      { min: 101, max: Infinity, price: 8.5 }
    ];
    const productAdd = { tshirt: 0, hoodie: 10.95, polo: -1.05 };
    const productNames = { tshirt: 'T-shirt', hoodie: 'Φούτερ', polo: 'Polo' };
    const frontAdd = { A6: 0, A5: 0, A4: 0, A3: 2.5 };
    const backAdd = { none: 0, A6: 2, A5: 2.5, A4: 3.5, A3: 6 };

    const money = (value) => `€${value.toFixed(2)}`;
    const baseForQty = (qty) => tiers.find((tier) => qty >= tier.min && qty <= tier.max)?.price ?? tiers[0].price;
    const unitPrice = () => baseForQty(state.qty) + productAdd[state.product] + frontAdd[state.front] + backAdd[state.back] + (state.sleeves * 2);

    const updateButtons = (selector, attr, value) => {
      root.querySelectorAll(selector).forEach((button) => {
        button.classList.toggle('is-active', button.dataset[attr] === String(value));
      });
    };

    const render = () => {
      const unit = unitPrice();
      const total = unit * state.qty;
      root.querySelector('[data-unit-price]').textContent = money(unit);
      root.querySelector('[data-total-price]').textContent = money(total);
      const backText = state.back === 'none' ? 'χωρίς πίσω εκτύπωση' : `πίσω ${state.back}`;
      const sleeveText = state.sleeves === 0 ? 'χωρίς μανίκια' : state.sleeves === 1 ? '1 μανίκι A6' : '2 μανίκια A6';
      root.querySelector('[data-summary]').textContent = `${productNames[state.product]} · ${state.qty} τεμ. · μπροστά ${state.front} · ${backText} · ${sleeveText}`;
    };

    root.querySelector('[data-qty]').addEventListener('input', (event) => {
      const qty = Math.max(1, parseInt(event.target.value || '1', 10));
      state.qty = Number.isFinite(qty) ? qty : 1;
      render();
    });

    root.querySelectorAll('[data-product]').forEach((button) => button.addEventListener('click', () => {
      state.product = button.dataset.product;
      updateButtons('[data-product]', 'product', state.product);
      render();
    }));
    root.querySelectorAll('[data-front]').forEach((button) => button.addEventListener('click', () => {
      state.front = button.dataset.front;
      updateButtons('[data-front]', 'front', state.front);
      render();
    }));
    root.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => {
      state.back = button.dataset.back;
      updateButtons('[data-back]', 'back', state.back);
      render();
    }));
    root.querySelectorAll('[data-sleeves]').forEach((button) => button.addEventListener('click', () => {
      state.sleeves = parseInt(button.dataset.sleeves, 10);
      updateButtons('[data-sleeves]', 'sleeves', state.sleeves);
      render();
    }));

    render();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
